import { size } from 'lodash';

import { MOCK_TOURIST } from '../routes/Checkout/store/constants/order';

export const makeMockTourists = (packageInfo) => {
  const { adults_count, kids_ages } = packageInfo;
  const touristsCount = adults_count + size(kids_ages);
  return Array(touristsCount).fill(MOCK_TOURIST);
};
